import type { Boundaries } from '../../../services/gql/types';
import type { DagDepthBoundary } from '../types';

export const getDagDepthBoundaryFromBoundaries = (
  assets: Boundaries,
  columns?: Boundaries,
): DagDepthBoundary => ({
  incomingDepth: Math.max(assets.upstream, columns?.upstream ?? 0),
  outgoingDepth: Math.max(assets.downstream, columns?.downstream ?? 0),
});
